import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function ResetPasswordForm() {
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const { token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/user/reset-password/${token}`, { password });
      setMsg("Mot de passe modifié !");
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setMsg("Lien invalide ou expiré.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Réinitialiser le mot de passe</h3>
      <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Nouveau mot de passe" />
      <button type="submit">Valider</button>
      <p>{msg}</p>
    </form>
  );
}
